module.exports = __webpack_public_path__ + "img/tenantsimg.3a465846.svg";